import { useDispatch } from 'react-redux';

/**
 * Custom hook that wraps the standard useDispatch hook to properly handle thunk actions
 * This allows for proper async/await usage with dispatch by ensuring the result is always a Promise
 * @returns {Function} Enhanced dispatch function
 */
export const useThunkDispatch = () => {
  const dispatch = useDispatch();
  
  return action => {
    const result = dispatch(action);
    
    // Ensure the result is always a Promise
    // This is what makes async/await work properly
    if (result && typeof result.then === 'function') {
      return result;
    }
    
    // If the result is not a Promise, wrap it in one
    return Promise.resolve(result);
  };
};
